import { render, staticRenderFns } from "./ActionPremiumEnd.vue?vue&type=template&id=4043316a&scoped=true"
import script from "./ActionPremiumEnd.vue?vue&type=script&lang=js"
export * from "./ActionPremiumEnd.vue?vue&type=script&lang=js"
import style0 from "./ActionPremiumEnd.vue?vue&type=style&index=0&id=4043316a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4043316a",
  null
  
)

export default component.exports